import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import CustomLink from '../custom-link/CustomLink';
import { pageType } from '../../interfaces';

type HeaderGlobalProps = {
  homepage?: boolean;
  pageType: pageType;
};
export default class HeaderGlobal extends React.Component<HeaderGlobalProps> {
  render() {
    return (
      <div
        id="global-nav"
        className="bg-light w-100 flex-grow-1 order-3 order-lg-1">
        <div className="container pb-9 pb-md-0">
          <div className="col d-lg-flex justify-content-lg-between global-nav-wrp position-relative pb-4 pb-md-0">
            <ul className="col-first pt-4 pt-lg-0 pb-3 pb-lg-0 mb-5 mb-lg-0">
              <li>
                <a
                  href="#main"
                  className="visually-hidden-focusable bg-white p-0 m-0 position-absolute">
                  Skip to main content
                </a>
              </li>
              <li className="d-none d-lg-inline pe-lg-6">
                <CustomLink
                  isLink={this.props.pageType === 'product'}
                  href="/"
                  data-link-both="globalnav-public-header-consumer">
                  Consumer
                </CustomLink>
              </li>
              <li className="pe-lg-6">
                <a
                  href="/small-business/"
                  data-link-both="globalnav-public-header-smallbusiness">
                  Small Business
                </a>
              </li>
              <li>
                <a
                  href="/business/"
                  data-link-both="globalnav-public-header-business">
                  Business
                </a>
              </li>
            </ul>
            <ul>
              {this.props.homepage ? (
                <Dropdown
                  drop="down-centered"
                  as="li"
                  autoClose="outside"
                  className="pe-lg-6"
                  focusFirstItemOnShow="keyboard">
                  <Dropdown.Toggle
                    as="button"
                    type="button"
                    id="hmp-nav-crd-support"
                    className="btn-reset py-lg-3 pe-lg-4 w-100"
                    data-link-both="globalnav-public-header-creditsupport">
                    Credit Support
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    align={{ lg: 'start' }}
                    aria-labelledby="hmp-nav-crd-support"
                    renderOnMount
                    as="ul"
                    className="pb-0 pt-3 py-lg-3">
                    <li>
                      <Dropdown.Item
                        href="https://www.annualcreditreport.com/"
                        target="_blank"
                        rel="noreferrer"
                        data-link-both="globalnav-public-header-cs-freeannualcreditreport">
                        Free annual credit report
                      </Dropdown.Item>
                    </li>
                    <li>
                      <Dropdown.Item
                        href="/disputes/main.html"
                        data-link-both="globalnav-public-header-cs-disputes">
                        Disputes
                      </Dropdown.Item>
                    </li>
                    <li>
                      <Dropdown.Item
                        href="/help/fraud-alert/"
                        data-link-both="globalnav-public-header-cs-fraudalert">
                        Fraud alert
                      </Dropdown.Item>
                    </li>
                    <li>
                      <Dropdown.Item
                        href="/help/credit-freeze/"
                        data-link-both="globalnav-public-header-cs-securityfreeze">
                        Security freeze
                      </Dropdown.Item>
                    </li>
                    <li>
                      <Dropdown.Item
                        href="/reportaccess/"
                        data-link-both="globalnav-public-header-cs-deniedcredit">
                        Denied credit
                      </Dropdown.Item>
                    </li>
                    <li>
                      <Dropdown.Item
                        href="/help/identity-theft-victim-assistance.html"
                        data-link-both="globalnav-public-header-cs-idtheft">
                        ID theft victim assistance
                      </Dropdown.Item>
                    </li>
                    <li>
                      <Dropdown.Item
                        href="/lp/military.html"
                        data-link-both="globalnav-public-header-cs-activemilitary">
                        Active duty military
                      </Dropdown.Item>
                    </li>
                    <li>
                      <Dropdown.Item
                        href="/blogs/ask-experian/credit-education/faqs/preapproved-credit-offers/opt-out/"
                        data-link-both="globalnav-public-header-cs-optout">
                        Opt out of prescreen offers
                      </Dropdown.Item>
                    </li>
                    <li>
                      <Dropdown.Item
                        href="/contact/personal-services-contacts.html"
                        data-link-both="globalnav-public-header-cs-contactus">
                        Contact us
                      </Dropdown.Item>
                    </li>
                    <li>
                      <Dropdown.Item
                        href="/help/"
                        data-link-both="globalnav-public-header-cs-allcreditsupport">
                        See all credit support
                      </Dropdown.Item>
                    </li>
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <li className="pe-lg-6">
                  <a
                    href="/help/"
                    data-link-both="globalnav-public-header-cunsumersupport">
                    Consumer Support
                  </a>
                </li>
              )}
              <li className="pe-lg-6">
                <CustomLink
                  isLink={this.props.pageType === 'blog'}
                  href="/blogs/ask-experian/"
                  data-link-both="globalnav-public-header-financialadvice">
                  Financial Advice
                </CustomLink>
              </li>
              <li>
                <a
                  rel="noreferrer noopener"
                  target="_blank"
                  href="https://www.experianplc.com/contact-us/region/"
                  data-link-both="globalnav-public-header-globalsites">
                  Global Sites
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
